import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ContractorSchedulingIndexTable from './ContractorSchedulingIndexTable';

function ContractorSchedulingIndex(props) {
    return (
        <div className="row p-2">
            <div className="col">
                <ContractorSchedulingIndexTable
                    contractorSchedulingCreateUrl={contractorSchedulingCreateUrl}
                    venuesUrl={venuesUrl}
                    departmentsUrl={departmentsUrl}
                />
            </div>
        </div>
    );
}

export default ContractorSchedulingIndex;
if (document.getElementById('ContractorSchedulingIndex')) {
    var rootEl = document.getElementById('ContractorSchedulingIndex');
    ReactDOM.render(
        <App>
            <ContractorSchedulingIndex />
        </App>,
        rootEl,
    );
}
